
import PageTitle from "../../components/PageTitle.vue";

export default {
	components: { PageTitle },
	data() {
		return {
			cargar: false,
			consultaTable: true,
			title: "Empresa",
			titleForm: "Empresa",
			totalRows: 1,
			currentPage: 1,
			perPage: 20,
			fields: [
				{ key: "acciones", 			label: "Acciones", 	sortable: false },
				{ key: "tipo_documento", 	label: "Tipo Doc", 		sortable: true },
				{ key: "numDocumento", 		label: "Num°", 		sortable: true },
				{ key: "razonSocial", 		label: "Razon Social o Nombre Completos", 	sortable: true },
				{ key: "email", 			label: "Correo", 	sortable: true },
				{ key: "movil", 			label: "Movil", 	sortable: true },
				{ key: "fijo", 				label: "Fijo", 	sortable: true },
				{ key: "ubigeo", 			label: "Ubigeo", 	sortable: true },
				{ key: "direccionFiscal", 	label: "Direccion", sortable: true },
				{ key: "estado", 			label: "Estado", 	sortable: true }],
			items: [],
			filter: null,
			departamentos: [],
			provincias: [],
			distritos: [],
			tipoDocumentos: [],
			form: {
				tipo_documento_id: "",
				numDocumento: "",
				razonSocial: "",
				razonComercial: "",
				direccionFiscal: "",
				email: "",
				emailOne: "",
				emailDo: "",
				movil: "",
				fijo: "",
				detraccion: "",
				detalle: "",
				department_id: "",
				province_id: "",
				district_id: "",
				solUsuario: "",
				solPassword: "",
				certificado: "",
			},
			file: "",
			isBusy: false,
		};
	},
	watch: {
		async "form.department_id"(newValor, oldValor) {
			let { data } = await this.axios.get('provincias/' + newValor);
			this.provincias = data;
		},
		async "form.province_id"(newValor, oldValor) {
			let { data } = await this.axios.get('distritos/' + newValor);
			this.distritos = data;
		},
	},
	computed: {
		sortOptions() {
			// Create an options list from our fields
			return this.fields
				.filter((f) => f.sortable)
				.map((f) => {
					return { text: f.label, value: f.key };
				});
		},
		numUltimo(){
			let end = this.totalRows;
			let itemsPerPage = this.currentPage * this.perPage;

			if (itemsPerPage < this.totalRows) {
				end = itemsPerPage;
				if (end > this.totalRows) {
				end = this.totalRows;
				}
			}
			return end;
		}
	},
	methods: {
		async inputFile(e){
			this.file = this.$refs.file.files[0];
		},
		async init() {
			let resp: any = '';
			this.listar();

			resp = await this.axios.get('departamentos');
			this.departamentos = resp.data;

			resp = await this.axios.get('select/tipoDocumentos');
			this.tipoDocumentos = resp.data;
		},
		async listar() {
			try {			
				let { data } = await this.axios.get('companies');
				this.items = data;	
				this.totalRows = this.items.length;
			} catch (error) {				
				this.catchAction(error);
			}
		},
		async show(id = 0) {
			this.cargar = true;
			try {
				this.reset();
				if (id > 0) {
					let { data } = await this.axios.get('companies/' + id);
					this.form = data;
				}
				this.cargar = false;
				// @ts-ignore
				$(".modal").modal({ backdrop: 'static', keyboard: false })
			} catch (error) {
				this.cargar = false;
				this.catchAction(error);
			}
		},
		async state(item, state) {
			let title = 'Activar?';
			let confirmButtonText = 'Si, Activar.';
			if (state == 0) {
				title = 'Desactivar?';
				confirmButtonText = 'Si, Desactivar.';
			}

			this.$swal.fire({
				title: title,
				text: item.fullname,
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				cancelButtonText: 'Cancelar',
				confirmButtonText: confirmButtonText,
				showLoaderOnConfirm: true,
				preConfirm: (login) => {
					return this.axios.patch('companies/' + item.id + '/state', { isActive: state })
						.then((result) => {
							return result.data;
						}).catch((err) => {
							this.$swal.showValidationMessage(
								`Request failed: ${err}`
							)
						});
				},
				allowOutsideClick: () => !this.$swal.isLoading()
			}).then((result) => {
				if (result.isConfirmed) {
					this.$swal.fire(
						'Estado',
						result.value.msg,
						'success'
					)
					this.listar();
				}
			});
		},
		reset() {
			this.form = {
				tipo_documento_id: "",
				numDocumento: "",
				razonSocial: "",
				razonComercial: "",
				direccionFiscal: "",
				email: "",
				emailOne: "",
				emailDo: "",
				movil: "",
				fijo: "",
				detraccion: "",
				detalle: "",
				department_id: "",
				province_id: "",
				district_id: "",
				solUsuario: "",
				solPassword: "",
				certificado: "",
			}

			this.file = '';
			let file:any = document.getElementById('file');
			//file.value  = '';
		},
		async submit(e) {
			e.preventDefault();
			let data: any = '';
			this.cargar = true;
			try {
				if (this.form.id > 0) {
					let resp = await this.axios.put('companies/' + this.form.id, this.form);
					data = resp.data;
				} else {
					let resp = await this.axios.post('companies', this.form);
					data = resp.data;
				}

				if(this.file && data.data.id > 0){
					let formData = new FormData();
			 		formData.append('id',data.data.id);
					formData.append('file',this.file);
					await this.axios.post('companies/certificado', formData);				
				}

				this.listar();
				this.cargar = false;
				// @ts-ignore
				$(".modal").modal('hide');
				// @ts-ignore
				new PNotify({
					text: data.msg,
					type: 'success',
					styling: 'bootstrap3'
				});
			} catch (error) {
				this.cargar = false;				
				this.catchAction(error);
			}
		},
		onFiltered(filteredItems) {
			// Trigger pagination to update the number of buttons/pages due to filtering
			this.totalRows = filteredItems.length;
			this.currentPage = 1;
		},
	},
	mounted() {
		// Set the initial number of items
		this.init();
	},
};
